module.exports = __webpack_public_path__ + "assets/media/day18.080278d4.mp3";